var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1479_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.692307C5.75528 0.692307 0.692261 5.75533 0.692261 12C0.692261 18.2447 5.75528 23.3077 12 23.3077C18.2446 23.3077 23.3076 18.2447 23.3076 12C23.3076 5.75533 18.2446 0.692307 12 0.692307ZM12 21.8942C6.54399 21.8942 2.10572 17.456 2.10572 12C2.10572 6.54404 6.54399 2.10577 12 2.10577C17.4559 2.10577 21.8942 6.54404 21.8942 12C21.8942 17.456 17.4559 21.8942 12 21.8942ZM14.8269 7.75961H9.17303C8.79816 7.75961 8.43864 7.90853 8.17356 8.17361C7.90849 8.43868 7.75957 8.7982 7.75957 9.17308V14.8269C7.75957 15.2018 7.90849 15.5613 8.17356 15.8264C8.43864 16.0915 8.79816 16.2404 9.17303 16.2404H14.8269C15.2017 16.2404 15.5613 16.0915 15.8263 15.8264C16.0914 15.5613 16.2403 15.2018 16.2403 14.8269V9.17308C16.2403 8.7982 16.0914 8.43868 15.8263 8.17361C15.5613 7.90853 15.2017 7.75961 14.8269 7.75961Z",
    fill: "#EF4C45"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1479_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6154,
    height: 22.6154,
    fill: "white",
    transform: "translate(0.692261 0.692307)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.0dc87e6ae9bdd702d9075710e32eb3c7.svg";
export { ForwardRef as ReactComponent };